import data from "../../../../swagger-specs/api.yaml";
import ModelDefinitions from "../../../../src/components/model-definitions";
import * as React from 'react';
export default {
  data,
  ModelDefinitions,
  React
};